import { useAppDispatch } from "app.hook";
import { FormikErrors, FormikProps, useFormik } from "formik";
import React, { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ACCOUNT_LOGIN_ROUTE, ACCOUNT_RESET_PASSWORD_ROUTE } from "shared/constants/routes";
import useCallback from "shared/hooks/use-callback";
import { forgotPasswordAPI } from "states/account/account.api";
import { IForgotPasswordModel } from "states/account/account.models";
import { setLoading, showError } from "states/global-value/global-value.slice";
import { IconArrowLeft, IconSuccess } from "themes/icons";
import { PrimaryButton } from "themes/style-components/button";
import { FlexAuto, FlexContainer, FlexLeftContainer } from "themes/style-components/flex";
import { FormControl, FormError, FormGroup, FormGroupNotFlex } from "themes/style-components/form-group";
import { H3 } from "themes/style-components/typography";

const ForgotPasswordPage: FC = (props) => {
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [callbackQuery, callbackUrl] = useCallback("callback");
  const getCurrentHost = () => {
    return `${window.location.protocol === "http:" ? "http://" : "https://"}${window.location.hostname
      }`;
  };
  const formik: FormikProps<IForgotPasswordModel> = useFormik<IForgotPasswordModel>({
    initialValues: {
      email: "",
      appPath: `${ACCOUNT_RESET_PASSWORD_ROUTE}${callbackQuery}`,
      domain: getCurrentHost(),
    },
    validateOnChange: true,
    validate: (values) => {
      let errors: FormikErrors<IForgotPasswordModel> = {};
      if (values.email === "") {
        errors.email = "Please enter email";
      }

      return errors;
    },

    onSubmit: async (values) => {
      dispatch(setLoading(true));
      try {
        if(values !== null && values.email !== null && values.email !== ""){
          values.email = values.email.toLowerCase();
        }
        await forgotPasswordAPI(values);
        dispatch(setLoading(false));
        setSuccess(true);
      } catch (err  : any) {
        dispatch(setLoading(false));
        dispatch(showError(err?.response?.data?.error?.message));
      }
    },
  });
  useEffect(() => {
    document.title = "Forgot password";
  }, [])
  return (
    <div>
      <FlexContainer>
        <FlexLeftContainer>
          <Link to={`${ACCOUNT_LOGIN_ROUTE}${callbackQuery}`}>
            <IconArrowLeft width={15} />
          </Link>
        </FlexLeftContainer>
        <FlexAuto className="text-center">
          <H3 className="mb-8">Forgot Password</H3></FlexAuto>
      </FlexContainer>
      {isSuccess ? (
        <div className="text-center mx-auto">
          <IconSuccess width={50} className="mb-3 text-center mx-auto" />
          <p>Send email successfully</p>
          <p>Please check your email</p>
        </div>
      ) : (<form onSubmit={formik.handleSubmit}>
        <FormGroupNotFlex>
          <FormControl>
            <input id="email"
              name="email"
              type="text"
              placeholder="Email"
              onChange={formik.handleChange}
              value={formik.values.email} />
          </FormControl>
          {formik.errors.email && (
            <FormError>
              {formik.errors.email}
            </FormError>
          )}
        </FormGroupNotFlex>
        <PrimaryButton className="block w-full mt-4" type="submit">Submit</PrimaryButton>
      </form>)}
    </div>
  );
};

export default ForgotPasswordPage;
